/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const data = {
    img: "https://i.ibb.co/0M89YJH/Soldassetdesc.png",
    title: "Sold Assets Description",
    description:
      "",
    meta: [
      {
        key: "",
        value: "In this section you can view the assets that are Sold by you / your organisation in different Vantr supported marketplace.",
      },
      {
        key: " ",
        value: "From this section, you can,",
      },
      {
        key: "",
        value: "• View Asset Details",
      },
      {
        key: "",
        value: "• Transaction Details & Proofs",
      },
      {
        key: "",
        value: "- Read More",
      },
      {
        key: "",
        value: "• Sold Assets - Grid View",
        path: "/sold-assets",
      },
      {
        key: "",
        value: "• Sold Assets Table - Grid View",
        path: "/sold-assets-table",
      },
      // {
      //   key:
      //     "The Brand protection also provides user scans done on the product batches which are not on the Shelf anymore.",
      //   value: "",
      // },
    ],
    // buttons: [
    //   {
    //     key: "edit",
    //     title: "Edit",
    //   },
    // ],
  };